// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

/**
 * "Our measurement", "Golf i Sverige" — the readable name of a length's source.
 *
 * Falls back to the stored word for anything untranslated, the same way the shape kinds do: a
 * source added server-side must render as its own name rather than as a blank, because a length
 * whose provenance is invisible is exactly the thing CLAUDE.md §19 is about.
 *
 * One copy, because three screens ask this question — the per-hole length table, the course card
 * and the hole map's tee chips — and a label that disagreed between them would read as two
 * different sources.
 */
export const lengthSourceLabel = (
  source: string,
  t: (key: string) => string
): string => {
  const key = `courseHoleMap.lengthSource_${source}`;
  const label = t(key);
  return label === key ? source : label;
};
